import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
  import { EditorModule } from '@/store/modules/editor'
  import { CourseModule } from '@/store/modules/course'
  import useEditor from '@/composables/useEditor'
  import useCommonMixin from '@/composables/useCommonMixin'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import TrainingsMenuDropdownLoader from '@/components/loaders/TrainingsMenuDropdownLoader.vue'
  import { UserModule } from '@/store/modules/user'
  import { useRoute, useRouter } from 'vue-router/composables'
  import eventBus from '@/main'
  import type { CourseItem } from '@/services/interfaces/Course'
  import useCourse from '@/composables/useCourse'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingsMenuDropdown',
  emits: ['hide-dropdown'],
  setup(__props, { emit }) {

  
  const router = useRouter()
  const route = useRoute()
  const { hasPurchasedAtLeastACourse } = useCourse()
  const { inEditorMode } = useEditor(route)
  const { scrollIntoSection, isSachkundeCompany } = useCommonMixin()
  const { isDesktopDevice } = useBreakpoint()
  const { bookIcon, zapIcon, playCircleIcon, cardEmptyImage } = useIcons()
  const menuDropdown = ref(null as HTMLDivElement | null)
  const trainingSections = ref(null as HTMLDivElement | null)

  const courseSections = computed(() => {
    if (inEditorMode.value) return EditorModule.courseSections
    return CourseModule.courseSections
  })

  const loadingCourseSections = computed(() => courseSections.value === null)

  const courseSectionsAbstractDetails = computed(() => {
    if (isSachkundeCompany.value && !hasPurchasedAtLeastACourse.value) {
      const section = courseSections.value?.[0]
      return section
        ? [
          {
            id: section.id,
            name: section.name,
            description: section.description,
            icon: sectionIcon.value(0),
          },
        ]
        : []
    }
    return courseSections.value
      ?.filter((section) => section.id)
      .map((section, index) => ({
        id: section.id,
        name: section.name,
        description: section.description,
        icon: sectionIcon.value(index),
      }))
  })

  const sectionIcon = computed(() => (index: number) => {
    const icons = [bookIcon.value, zapIcon.value, playCircleIcon.value]
    if (icons[index]) return icons[index]
    return icons[0]
  })

  const purchasedTrainings = computed(() => {
    return courseSections.value?.reduce((acc, section) => {
      section.assignedCourses.forEach((course) => {
        if (course.purchased && course.visibleToGroup && !course.locked) {
          acc.push(course)
        }
      })
      return acc
    }, [] as CourseItem[])
  })

  const inTrialTrainings = computed(() => {
    return courseSections.value?.reduce((acc, section) => {
      section.assignedCourses.forEach((course) => {
        if (course.trial && course.visibleToGroup && !course.locked) {
          acc.push(course)
        }
      })
      return acc
    }, [] as CourseItem[])
  })

  const hasTrialOrPurchasedCourses = computed(() => purchasedTrainings.value?.length || inTrialTrainings.value?.length)

  const scrollToSection = (sectionId: string) => {
    if (isDesktopDevice.value) {
      emit('hide-dropdown')
    } else {
      eventBus.$emit('close-modal')
    }
    if (route.name !== 'Trainings') {
      router.push({ name: 'Trainings', query: { sectionId: sectionId } })
    } else {
      const element = document.getElementById(sectionId) as HTMLDivElement
      if (element) {
        const top = element.getBoundingClientRect().top
        scrollIntoSection(sectionId, top)
      }
    }
  }

  const setSubmenuHeight = (timeToWaitInMilliseconds: number) => {
    if (isDesktopDevice.value) {
      setTimeout(() => {
        const sectionsDiv = trainingSections.value
        if (sectionsDiv && menuDropdown.value) {
          const sectionsHeight = sectionsDiv.offsetHeight
          menuDropdown.value.style.height = `${sectionsHeight}px`
        }
      }, timeToWaitInMilliseconds)
    }
  }

  watch(loadingCourseSections, (value) => {
    if (!value) {
      setTimeout(() => {
        setSubmenuHeight(10)
      }, 10)
    }
  })

  watch(
    () => route.path,
    () => {
      if (isDesktopDevice.value) {
        emit('hide-dropdown')
      }
    },
  )

  if (route.name !== 'Trainings' && !courseSections.value) {
    if (UserModule.currentCompany?.id) {
      CourseModule.getCourseSections(UserModule.currentCompany.id)
    }
  }

  onMounted(() => {
    if (menuDropdown.value && !loadingCourseSections.value) {
      setSubmenuHeight(20)
    }
  })

return { __sfc: true,emit, router, route, hasPurchasedAtLeastACourse, inEditorMode, scrollIntoSection, isSachkundeCompany, isDesktopDevice, bookIcon, zapIcon, playCircleIcon, cardEmptyImage, menuDropdown, trainingSections, courseSections, loadingCourseSections, courseSectionsAbstractDetails, sectionIcon, purchasedTrainings, inTrialTrainings, hasTrialOrPurchasedCourses, scrollToSection, setSubmenuHeight, computed, onMounted, ref, watch, EditorModule, CourseModule, useEditor, useCommonMixin, SVGRenderer, useIcons, useBreakpoint, HTMLRenderer, TrainingsMenuDropdownLoader, UserModule, useRoute, useRouter, eventBus, useCourse }
}

})